import React from "react";
import { Link } from "react-router-dom";
import { SCREEN_GROUPS } from "../lib/screen-catalog.js";

export function HomePage({ counts }) {
  return (
    <div style={{ maxWidth: 980, margin: "0 auto", padding: "32px 12px" }}>
      <header style={{ marginBottom: 28 }}>
        <div className="mono" style={{ fontSize: 11, letterSpacing: "0.14em", color: "#86a3d9", textTransform: "uppercase" }}>
          EducaFinaz · educa1.iort.io
        </div>
        <h1 style={{ fontSize: 40, lineHeight: 1.05, letterSpacing: "-0.02em", margin: "10px 0 8px", fontWeight: 600 }}>
          El sistema educativo de Finaz, en pantallas reales.
        </h1>
        <p style={{ fontSize: 16, color: "#a8b9d9", maxWidth: 720 }}>
          Explorador navegable de las pantallas EducaFCEF v1.0. {counts.total} pantallas (
          {counts.materia ?? 0} desktop Materia · {counts.cristal ?? 0} mobile Cristal), datos sintéticos
          deterministas y charts reales con klinecharts. Los contenidos provienen de los 11 episodios
          YAML del paquete educativo y se cargarán de Finaz Data en producción.
        </p>
        <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
          <Link to="/p/hoy" className="ef-link" style={{ background: "rgba(95,214,193,0.12)", padding: "10px 16px", fontWeight: 500 }}>
            Abrir Hub · Materia
          </Link>
          <Link to="/p/m-hub" className="ef-link" style={{ padding: "10px 16px" }}>
            Hub mobile · Cristal
          </Link>
          <Link to="/catalogo" className="ef-link" style={{ padding: "10px 16px" }}>
            Catálogo editorial
          </Link>
        </div>
      </header>

      <section
        style={{
          background: "rgba(127,182,255,0.04)",
          border: "1px solid rgba(168,185,217,0.10)",
          padding: "18px 18px",
          borderRadius: 14,
          marginBottom: 22,
        }}
      >
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, fontSize: 13 }}>
          <Stat label="Pantallas" value={counts.total} />
          <Stat label="Materia desktop" value={counts.materia ?? 0} />
          <Stat label="Mobile Cristal" value={counts.cristal ?? 0} />
          <Stat label="Variantes activas" value="materia · cristal" />
        </div>
      </section>

      {SCREEN_GROUPS.map((g) => (
        <section
          key={g.id}
          style={{
            margin: "18px 0",
            padding: "16px 18px",
            borderRadius: 12,
            border: "1px solid rgba(168,185,217,0.08)",
          }}
        >
          <h2 style={{ margin: "0 0 8px", fontSize: 17, fontWeight: 600 }}>{g.title}</h2>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {g.items
              .filter((it) => it.component)
              .map((it) => (
                <Link key={it.slug} to={`/p/${it.slug}`} className="ef-link" style={{ padding: "6px 10px", border: "1px solid rgba(168,185,217,0.10)" }}>
                  {it.label}
                </Link>
              ))}
          </div>
        </section>
      ))}

      <footer style={{ marginTop: 40, color: "#6e85b3", fontSize: 12 }}>
        <p>
          <span className="mono">EducaFinaz</span> · contenido educativo · no es asesoramiento financiero ·
          fuentes y timestamps visibles en cada pantalla · {new Date().getFullYear()}
        </p>
      </footer>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="mono" style={{ fontSize: 10, color: "#6e85b3", textTransform: "uppercase", letterSpacing: "0.1em" }}>
        {label}
      </div>
      <div style={{ fontSize: 24, fontWeight: 600, marginTop: 4 }}>{value}</div>
    </div>
  );
}
